// Thin, safe wrapper around GA4 gtag. No-ops if gtag isn't loaded.
export const trackEvent = (name, params = {}) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
};

// Delegated click tracking for tel: and WhatsApp links across the whole site.
export const initLinkTracking = () => {
  if (typeof document === "undefined") return () => {};
  const handler = (e) => {
    const link = e.target.closest && e.target.closest("a");
    if (!link) return;
    const href = (link.getAttribute("href") || "").toLowerCase();
    if (href.startsWith("tel:")) {
      trackEvent("phone_click", { link_text: "phone number clicked" });
    } else if (href.includes("wa.me") || href.includes("whatsapp.com") || href.includes("api.whatsapp")) {
      trackEvent("whatsapp_click");
    }
  };
  document.addEventListener("click", handler, true);
  return () => document.removeEventListener("click", handler, true);
};
